import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { moveActivePane } from '@disco/state-management/actions/ExplorerActions'
import Button from 'components/ui/button'

const MobilePaneSwitch = (): React.ReactElement<'div'> => {
  const dispatch = useDispatch()
  const activePane = useSelector(state => state.explorer.activePane)
  const panesLength = useSelector(state => state.explorer.panes.length)
  const moveBack = useCallback(() => dispatch(moveActivePane(-1)), [dispatch])
  const moveForward = useCallback(() => dispatch(moveActivePane(1)), [dispatch])
  return (
    <div>
      <Button
        appearance="icon"
        disabled={activePane === 0}
        onClick={moveBack}
        icon="arrow-left"
      />
      <Button
        appearance="icon"
        disabled={panesLength - 1 === activePane}
        onClick={moveForward}
        icon="arrow-right"
      />
    </div>
  )
}

export default MobilePaneSwitch
